/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useRef, useMemo, useCallback} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation} from 'react-i18next'
import i18next from 'i18next'
import axios from 'axios'
import Pagination from '../component/Pagination'
import {createDate, updateDate, deleteDate} from '../../../api/modules/dateconfig'
import CustomUseEffect from '../component/CustomUseEffect'
import {getSalesAreaLetter, getSectorAll} from '../../../api/modules/getdatalist'
import swal from 'sweetalert'
import CurrencyInput from 'react-currency-input-field'
import {Spinner} from 'react-bootstrap'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {fetchConfigDate, headers} from '../../../services/fetcher'
import {objToParams} from '../../../utils/objToParams'
import {RowFilter} from './RowFilter'
import {
  filterSelector,
  resetFilterDate,
  setFilterDate,
  setIsFetchData,
} from '../../../redux/slices/filterSlices'
import {SelectPageSize} from '../../../components/SelectPageSize/SelectPageSize'
import {useRowTable} from '../../../hooks/useRowTable'
import * as TableUI from '../../../components/Table/Table'
import {RowHead} from './RowHead'
import {StyledCard} from '../../../components/StyledCard'
import {StyledButtonGroups} from '../../../components/StyledButtonGroups'
import { MultiSelect } from 'react-multi-select-component'
import { PopoverText } from 'src/components'

type Props = {
  className: string
}

const TableTanggal: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()
  const {filterDate} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const [page, setPage] = useState(0)
  const [per, setPer] = useState(0)
  const [loading, setLoading] = useState(true)
  const [btnLoading, setBtnLoading] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [fullSales, setFullSales] = useState<any[]>([])
  const [fullSektor, setFullSektor] = useState<any[]>([])

  const [sales, setSales] = useState<any[]>([])
  const [sektor, setSektor] = useState<any[]>([])
  const [min, setMin] = useState<any>(0)
  const [max, setMax] = useState<any>(0)
  const [time, setTime] = useState(0)
  const [timetype, setTimetype] = useState('')
  const [active, setActive] = useState('')
  const [tempID, setTempID] = useState(0)
  const [allDate, setAllDate] = useState<any[]>([])
  const [showAdd, setShowAdd] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [tiny, setTiny] = useState<any>()
  const [isError, setisError] = useState(false)

  const [roleUser, setRoleUser] = useState('')
  const [language, setLanguage] = useState<any>()

  const [listtime] = useState([
    {value: 'D', label: 'Days'},
    {value: 'H', label: 'Hours'},
  ])

  const editorRef: any = useRef()
  const onClickHandler = () => {
    setTiny(editorRef.current.getContent())
  }

  const handleCreate = async () => {
    setBtnLoading(true)
    let tempactive = false
    if (active == 'true') tempactive = true
    else tempactive = false

    const payload = {
      sales_org_codes: sales.map((item: any) => item.value),
      sector_ids: sektor.map((item: any) => item.value),
      minimum_tonnage: parseInt(min),
      max_tonnage: parseInt(max),
      time: time,
      time_type: timetype,
      is_active: tempactive,
      credentials: localStorage.getItem('credential'),
    }
    await createDate(payload)
      .then((res) => {
        swal({
          title: `${t('Configuration Date Uploaded Successfully')}`,
          icon: 'success',
        }).then(() => {
          onFetchData()
          setShowAdd(false)
        })
      })
      .catch((error) => {
        swal({
          closeOnClickOutside: false,
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleEdit = async () => {
    setBtnLoading(true)
    let tempactive = false
    if (active == 'true') tempactive = true
    else tempactive = false
    const payload = {
      sales_org_codes: sales.map((item: any) => item.value),
      sector_ids: sektor.map((item: any) => item.value),
      minimum_tonnage: min,
      max_tonnage: max,
      time: time,
      time_type: timetype,
      is_active: tempactive,
      credentials: localStorage.getItem('credential'),
    }

    await updateDate(tempID, payload)
      .then((res) => {
        swal({
          title: `${t('Configuration Date Edited Successfully')}`,
          icon: 'success',
        }).then(() => {
          setActived(!actived)
          setShowEdit(false)
          onFetchData()
        })
      })
      .catch((error) => {
        swal({
          closeOnClickOutside: false,
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const dropLetter = async () => {
    swal({
      title: t('Are you sure?'),
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        setBtnLoading(true)
        await deleteDate(tempID, localStorage.getItem('credential'))
          .then((res) => {
            swal({
              title: t('Configuration Date Deleted Successfully'),
              icon: 'success',
            })
            setShowDelete(false)
            setActived(!actived)
            onFetchData()
          })
          .catch(function (error) {
            if (error.response) {
              swal({
                title: `${error.response.data.message}`,
                icon: 'error',
              })
            }
          })
          .finally(() => {
            setBtnLoading(false)
          })
      }
    })
  }

  const rowNumber = useMemo(() => {
    const per = filterDate?.per_page ?? 5
    return page * per - per
  }, [filterDate?.per_page, page])

  const onReloadTable = () => {
    dispatch(resetFilterDate())
  }

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 8,
    onReloadTable,
  })

  const paginateNumber = async (url: string) => {
    try {
      setLoading(true)

      const token = localStorage.getItem('token')
      const credentials = localStorage.getItem('credential')
      const endpoint = `${url}&credentials=${credentials}&${objToParams(filterDate)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      const data = res.data.data

      setAllDate(data.data)
      setPage(data.current_page)
      setNumberURL(data.links)
    } catch (error) {
      setisError(true)
    } finally {
      setLoading(false)
      dispatch(setIsFetchData(false))
    }
  }

  const onFetchData = useCallback(() => {
    setLoading(true)
    setisError(false)
    fetchConfigDate(filterDate)
      .then((res) => {
        setAllDate(res.data.data.data)
        setPage(res.data.data.current_page)
        setPer(res.data.data.per_page)
        setNumberURL(res.data.data.links)
      })
      .catch((err) => setisError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterDate])

  /** @deprecated use onFetchData for getting the date config data from server */
  const getAllDate = async () => {
    setLoading(true)
    await fetchConfigDate()
      .then((res) => {
        setAllDate(res.data.data.data)
        setPage(res.data.data.current_page)
        setPer(res.data.data.per_page)
        setNumberURL(res.data.data.links)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const getAllSales = async () => {
    await getSalesAreaLetter().then((res) => {
      setFullSales(res.data.data)
    })
  }
  const getSector = async () => {
    const res = await getSectorAll()
    setFullSektor(res.data.data)
  }

  useEffect(() => {
    // getAllDate()
    getSector()
    getAllSales()
    setRoleUser(localStorage.getItem('role-flag')!)
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const [actived, setActived] = useState(false)

  useEffect(() => {
    const getData = setTimeout(onFetchData, 1000)
    return () => clearTimeout(getData)
  }, [onFetchData])

  const handleEditModal = (data: any) => {
    setShowEdit(true)
    setTempID(data?.id)
    setSales(data?.sales_orgs.map((item: any) => {
      return {
        label: item.name,
        value: item.code,
      }
    }))
    setSektor(data?.sectors.map((item: any) => {
      return {
        label: item.name,
        value: item.id,
      }
    }))
    setMin(data?.minimum_tonnage)
    setMax(data?.max_tonnage)
    setTime(parseInt(data?.time))
    setTimetype(data?.time_type)
    setActive(String(data?.is_active))
  }

  CustomUseEffect(() => {
    const time = document.getElementById('time') as HTMLInputElement
    if (time != null) time.value = ''
    const waktu = document.getElementById('waktu') as HTMLSelectElement
    if (waktu != null) waktu.selectedIndex = 0
    const status = document.getElementById('status') as HTMLSelectElement
    if (status != null) status.selectedIndex = 0
  }, [sales])

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterDate({...filterDate, per_page: value ?? 5}))
  }

  useEffect(() => {
    return () => {
      dispatch(resetFilterDate())
    }
  }, [])

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <SelectPageSize
            initialValue={filterDate?.per_page ?? 5}
            onChange={(value: any) => handlePageSizeChange(value?.value)}
          />
        }
        rightContent={
          <button
            className='btn btn-primary d-flex align-items-center'
            onClick={() => setShowAdd(true)}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
            <p>{t('order-tambah') + ' ' + t('order-tanggal')}</p>
          </button>
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <RowHead />
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : allDate.length === 0 ? (
              <RowEmptyData />
            ) : (
              allDate.map((data: any, _index: number) => (
                <tr key={data?.id ?? _index}>
                  <td>{_index + 1 + rowNumber}</td>
                  <td>
        <PopoverText
          content={
            data?.sectors.length > 0
              ? data?.sectors
                  .map((item: any, index: number) => {
                    return item.name
                  })
                  .join(', ')
              : '-'
          }
          index={rowNumber}
          trigger='click'
          className='desc-slicee'
        />
      </td>
      <td>
        <PopoverText
          content={
            data?.sales_orgs.length > 0
              ? data?.sales_orgs
                  .map((item: any, index: number) => {
                    return item.name
                  })
                  .join(', ')
              : '-'
          }
          index={rowNumber}
          trigger='click'
          className='desc-slicee'
        />
      </td>
                  <td>
                    {i18next.language === 'en'
                      ? data.minimum_tonnage?.toLocaleString('en', {
                          maximumFractionDigits: 4,
                        })
                      : data.minimum_tonnage?.toLocaleString('id', {
                          maximumFractionDigits: 4,
                        })}
                  </td>
                  <td>
                    {i18next.language === 'en'
                      ? data.max_tonnage?.toLocaleString('en', {maximumFractionDigits: 4})
                      : data.max_tonnage?.toLocaleString('id', {maximumFractionDigits: 4})}
                  </td>
                  <td>{ parseInt(data?.time)}</td>
                  <td>{data?.time_type === 'D' ? t('Days') : t('Hours')}</td>
                  <td>
                  <span className='d-block '>
          {!data.is_active ? (
            <span className='badge badge-light-danger'>{t('Non-Active')}</span>
          ) : (
            <span className='badge badge-light-success'>{t('Active')}</span>
          )}
        </span>
                  </td>
                  <td>
                    <button
                      onClick={() => {
                        handleEditModal(data)
                      }}
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('ubah')}
                    >
                      <KTSVG path='/media/icons/duotune/pencil-fill.svg' className='svg-icon-3' />
                    </button>
                    <button
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('Hapus')}
                      onClick={() => {
                        setTempID(data.id)
                        setShowDelete(true)
                      }}
                    >
                      <KTSVG path='/media/icons/duotune/trash-fill.svg' className='svg-icon-3' />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal
        show={showAdd}
        onHide={() => setShowAdd(false)}
        backdrop='static'
        keyboard={false}
        centered
        size='lg'
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('order-tambah')} {t('Configuration')} {t('order-tanggal')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>{t('Sector')}</Form.Label>
            </Col>
            <Col sm={9}>
            <MultiSelect
                options={fullSektor?.map((item: any) => {
                  return {label: t(item.name), value: item.id}
                })}
                value={sektor}
                onChange={setSektor}
                labelledBy='Select'
              />
            </Col>
            </Row>
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>Sales Org</Form.Label>
            </Col>
            <Col sm={9}>
              <MultiSelect
                  options={fullSales?.map((item: any) => {
                    return {label: t(item.name), value: item.code}
                  })}
                  value={sales}
                  onChange={setSales}
                  labelledBy='Select'
                />
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>
                {t('Minimal')} {t('kuantitas')}
              </Form.Label>
            </Col>
            <Col sm={9}>
              <CurrencyInput
                className='form-control form-control-sm'
                placeholder={t('Minimal') + ' ' + t('kuantitas')}
                decimalSeparator={language === 'en' ? '.' : ','}
                groupSeparator={language === 'en' ? ',' : '.'}
                onValueChange={(value: any) => {
                  setMin(value?.replace(/,/g, '.'))
                }}
                decimalsLimit={3}
              />
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>
                {t('Maksimal')} {t('kuantitas')}
              </Form.Label>
            </Col>
            <Col sm={9}>
              <CurrencyInput
                className='form-control form-control-sm'
                id='kuantum'
                placeholder={t('Maksimal') + ' ' + t('kuantitas')}
                decimalSeparator={language === 'en' ? '.' : ','}
                groupSeparator={language === 'en' ? ',' : '.'}
                onValueChange={(value: any) => {
                  setMax(value?.replace(/,/g, '.'))
                }}
                decimalsLimit={3}
              />
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>{t('Time')}</Form.Label>
            </Col>
            <Col sm={9}>
              <Form.Control
                id='time'
                placeholder={t('Time')}
                size='sm'
                type='number'
                onChange={(e: any) => setTime(parseInt(e.target.value))}
              />
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>{t('time desc')}</Form.Label>
            </Col>
            <Col sm={9}>
              <Form.Select
                aria-label='Default select example'
                onChange={(e: any) => setTimetype(e.target.value)}
                size='sm'
                id='waktu'
              >
                <option value=''>
                  {t('pilih')} {t('time desc')}
                </option>
                {listtime.map((data: any, index: number) => {
                  return (
                    <option key={data?.value ?? index} value={data.value}>
                      {t(data.label)}
                    </option>
                  )
                })}
              </Form.Select>
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>Status</Form.Label>
            </Col>
            <Col sm={9}>
              <Form.Select
                aria-label='Default select example'
                onChange={(e: any) => setActive(e.target.value)}
                size='sm'
                id='status'
              >
                <option value=''>{t('pilih')} Status</option>
                <option value='false'>{t('Inactive')}</option>
                <option value='true'>{t('Active')}</option>
              </Form.Select>
              {/* <Form.Check
                reverse
                name='isactive'
                className='mt-5 mb-2'
                type='checkbox'
                id='ckbox-active'
              /> */}
            </Col>
          </Row>
          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={() => handleCreate()} disabled={btnLoading}>
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                <>{t('order-tambah')}</>
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        backdrop='static'
        keyboard={false}
        centered
        size='lg'
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('Edit')} {t('Configuration')} {t('order-tanggal')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className='d-flex justify-content-center'>
              <Spinner animation='border' variant='primary' />
            </div>
          ) : (
            <>
               <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>{t('Sector')}</Form.Label>
            </Col>
            <Col sm={9}>
            <MultiSelect
                options={fullSektor?.map((item: any) => {
                  return {label: t(item.name), value: item.id}
                })}
                value={sektor}
                onChange={setSektor}
                labelledBy='Select'
              />
            </Col>
            </Row>
              <Row className='mb-5'>
                <Col sm={3}>
                  <Form.Label>Sales Org</Form.Label>
                </Col>
                <Col sm={9}>
                <MultiSelect
                  options={fullSales?.map((item: any) => {
                    return {label: t(item.name), value: item.code}
                  })}
                  value={sales}
                  onChange={setSales}
                  labelledBy='Select'
                />
                </Col>
              </Row>
              <Row className='mb-5'>
                <Col sm={3}>
                  <Form.Label>
                    {t('Minimal')} {t('kuantitas')}
                  </Form.Label>
                </Col>
                <Col sm={9}>
                  <CurrencyInput
                    className='form-control form-control-sm'
                    defaultValue={min}
                    placeholder={t('Minimal') + ' ' + t('kuantitas')}
                    decimalSeparator={language === 'en' ? '.' : ','}
                    groupSeparator={language === 'en' ? ',' : '.'}
                    onValueChange={(value: any) => {
                      setMin(value?.replace(/,/g, '.'))
                    }}
                    decimalsLimit={3}
                  />
                </Col>
              </Row>
              <Row className='mb-5'>
                <Col sm={3}>
                  <Form.Label>
                    {t('Maksimal')} {t('kuantitas')}
                  </Form.Label>
                </Col>
                <Col sm={9}>
                  <CurrencyInput
                    className='form-control form-control-sm'
                    placeholder={t('Maksimal') + ' ' + t('kuantitas')}
                    defaultValue={max}
                    decimalSeparator={language === 'en' ? '.' : ','}
                    groupSeparator={language === 'en' ? ',' : '.'}
                    onValueChange={(value: any) => {
                      setMax(value?.replace(/,/g, '.'))
                    }}
                    decimalsLimit={3}
                  />
                </Col>
              </Row>
              <Row className='mb-5'>
                <Col sm={3}>
                  <Form.Label>{t('Time')}</Form.Label>
                </Col>
                <Col sm={9}>
                  <Form.Control
                    placeholder={t('Time')}
                    size='sm'
                    type='number'
                    defaultValue={time}
                    onChange={(e: any) => setTime(parseInt(e.target.value))}
                  />
                </Col>
              </Row>
              <Row className='mb-5'>
                <Col sm={3}>
                  <Form.Label>{t('Waktu')} Desc</Form.Label>
                </Col>
                <Col sm={9}>
                  <Form.Select
                    aria-label='Default select example'
                    onChange={(e: any) => setTimetype(e.target.value)}
                  >
                    <option selected hidden value=''>
                      {t('pilih')} {t('Waktu')} Desc
                    </option>
                    {listtime.map((data: any) => {
                      return (
                        <>
                          {data.value == timetype ? (
                            <option selected value={data.value}>
                              {t(data.label)}
                            </option>
                          ) : (
                            <option value={data.value}>{t(data.label)}</option>
                          )}
                        </>
                      )
                    })}
                  </Form.Select>
                </Col>
              </Row>
              <Row className='mb-5'>
                <Col sm={3}>
                  <Form.Label>Status</Form.Label>
                </Col>
                <Col sm={9}>
                  <Form.Select
                    aria-label='Default select example'
                    onChange={(e: any) => setActive(e.target.value)}
                  >
                    {active == 'true' ? (
                      <>
                        <option selected value='true'>
                          {t('Active')}
                        </option>
                        <option value='false'>{t('Inactive')}</option>
                      </>
                    ) : (
                      <>
                        <option value='true'>{t('Active')}</option>
                        <option selected value='false'>
                          {t('Inactive')}
                        </option>
                      </>
                    )}
                  </Form.Select>
                  {/* <Form.Check
                defaultChecked={active}
                reverse
                name='isactive'
                className='mt-5 mb-2'
                type='checkbox'
                id='ckbox-active'
              /> */}
                </Col>
              </Row>
              <div className='d-flex justify-content-end'>
                <Button variant='primary' onClick={() => handleEdit()} disabled={btnLoading}>
                  {btnLoading ? (
                    <Spinner animation='border' variant='light' size='sm' />
                  ) : (
                    <>{t('Edit')}</>
                  )}
                </Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showDelete} onHide={() => setShowDelete(false)} centered backdrop='static'>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h3 className='text-center mb-5'>
            {t('Hapus')} {t('Konfigurasi Tanggal')}?
          </h3>
          <div className='d-flex justify-content-center'>
            <Button variant='secondary me-2' onClick={() => setShowDelete(false)}>
              {t('cancel')}
            </Button>
            <Button variant='danger' onClick={() => dropLetter()} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('Ya')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {TableTanggal}
